"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLineChartOptions = void 0;
var _color = require("../../styles/variables/_color");
var _charts = require("./charts");
var _helpers = require("./helpers");
var _typography = require("./typography");
/**
 * This function modifies the the common chart behavior to line chart default behavior.
 * It will not take userPassed option into account.
 */

const getLineChartOptions = () => ({
  ..._charts.commonChartOptions,
  chart: {
    type: 'line'
  },
  legend: {
    ..._charts.commonChartOptions.legend,
    ..._helpers.bottomLegendRow,
    symbolWidth: 18
  },
  xAxis: {
    ..._charts.commonChartOptions.xAxis,
    labels: {
      style: _typography.formLabelSmall
    },
    title: {
      margin: 12,
      style: _helpers.xAxisTitleStyle
    },
    lineColor: _color.colorBorderPrimary
  },
  yAxis: {
    labels: {
      align: 'right',
      distance: 12,
      style: _helpers.yAxisLabelStyle
    },
    title: {
      margin: 12,
      style: _helpers.yAxisTitleStyle
    }
  }
});
exports.getLineChartOptions = getLineChartOptions;